import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../config";

const Search = () => {
  const { id } = useParams(); 
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        window.location.href = "/login";
        return;
      }

      try {
        const response = await axios.get(`${BASE_URL}api/clients-info/find-all`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = Array.isArray(response.data) ? response.data : [];

        const filtered = data.filter((item) => {
          return (
            (item.DatabaseInfo || "").includes(id) ||
            (item.Domain || "").includes(id) ||
            (item.Emails || "").includes(id) ||
            (item.HostigValue || "").includes(id) ||
            (item.Hosting || "").includes(id) ||
            (item.FTPInfo || "").includes(id) ||
            (item.HostingBy || "").includes(id) ||
            (item.Others || "").includes(id) ||
            (item.Registrar || "").includes(id) ||
            (item.SVN || "").includes(id) ||
            (item.WPAdminCredentials || "").includes(id)
          );
        });

        setFilteredData(filtered);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  return (
    <div
      className="container mt-4"
      style={{ backgroundColor: "#f8f9fa", padding: "20px", borderRadius: "8px" }}
    >
      <div className="mb-3 d-flex justify-content-between">
        <h2>Important Information for: {id}</h2>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : filteredData.length === 0 ? (
        <p>No matching records found.</p>
      ) : (
        <ul className="list-group">
          {filteredData.map((item, index) => (
            <li key={index} className="list-group-item">
              {item.Domain ? (
                <a
                  href={`/clients-information/${item.Domain}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.Domain}
                </a>
              ) : (
                <span>No domain</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Search;
